import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="7mm"
    height={20.834}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21574 16989"
    {...props}
  >
    <path
      d="M21265 6857V1945H8054C7487 967 6430 308 5220 308c-1806 0-3275 1469-3275 3275v11461H308v1637h9824v-1637H8494V6857h12771zm-9154-1637 819-1638h3081l-818 1638h-3082zm7517 0h-2605l819-1638h1786v1638zm-8528-1638-819 1638H8494V3582h2606zM3583 15044V3582c0-902 734-1637 1637-1637s1637 735 1637 1637v11462H3583z"
      style={{
        // fill: "#000",
        // stroke: "#fefefe",
        strokeWidth: 616.388,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
